// extracted by mini-css-extract-plugin
export default {"filters":"IdentificationTagsScreen_filters__H0B6K"};